import { Package, Snowflake } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from './SectionHeader';
import { SummaryRow } from './SummaryRow';

interface PackageSectionProps {
  size: string;
  isFragile: boolean;
  idVerification?: boolean;
  temperatureControlled?: boolean;
}

export function PackageSection({
  size,
  isFragile,
  idVerification,
  temperatureControlled,
}: PackageSectionProps) {
  const { t } = useTranslation();

  return (
    <div className='rounded-2xl border border-sd-border bg-sd-card p-5'>
      <SectionHeader icon={Package} title={String(t('package_info'))} />

      <div className='divide-y divide-sd-border'>
        <SummaryRow label={String(t('size'))} value={String(t(size))} />
        <SummaryRow
          label={String(t('fragile'))}
          value={isFragile ? String(t('yes')) : String(t('no'))}
        />
        {/* TEMP-9 — cold-chain reads as a capability badge (Snowflake +
            blue-tinted tag), not a plain Yes value. Row renders ONLY when
            the order carries the flag. */}
        {!!temperatureControlled && (
          <SummaryRow label={String(t('temperature_controlled'))}>
            <span
              data-testid='temperature-control-badge'
              className='inline-flex items-center gap-1.5 rounded-full border border-blue-200 bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-blue-700'
            >
              <Snowflake className='h-3.5 w-3.5' strokeWidth={1.5} />
              {String(t('yes'))}
            </span>
          </SummaryRow>
        )}
        {!!idVerification && (
          <SummaryRow
            label={String(t('id_checked'))}
            value={String(t('yes'))}
          />
        )}
      </div>
    </div>
  );
}
